module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("品牌成交量前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [(_vm.topOrderAmount.brand) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('canvas', {
    attrs: {
      "id": "today-brand-top"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("店家成交量前五名")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [(_vm.topOrderAmount.store) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('canvas', {
    attrs: {
      "id": "today-store-top"
    }
  })]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getShopperStatus()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.roleType !== 10) ? _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 品牌 ==")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                    " + _vm._s(brand.label) + "\n                  ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 0 && _vm.brandSelect !== '0' && _vm.storeBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 門市 ==")]), _vm._v(" "), _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                    " + _vm._s(store.label) + "\n                  ")])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search2"
    },
    on: {
      "click": function($event) {
        return _vm.getShopperStatus()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("交易訂單統計"), (_vm.brandSelect === 0 || _vm.brandSelect === '0') ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("交易金額統計"), (_vm.brandSelect === 0 || _vm.brandSelect === '0') ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("交易數量統計"), (_vm.brandSelect === 0 || _vm.brandSelect === '0') ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("拒單原因統計"), (_vm.brandSelect === 0 || _vm.brandSelect === '0') ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_vm._m(6), _vm._v(" "), (_vm.rejectedOrderList) ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "500px"
    }
  }, [(_vm.rejectedOrderList.length) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.rejectedOrderList), function(reject, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [(reject.date) ? _c('td', {
      attrs: {
        "rowspan": reject.reasonAmount
      }
    }, [_vm._v(_vm._s(_vm.getMonthDay(reject.date)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(reject.reject_reason) + " (" + _vm._s(reject.reject_status) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(reject.order_count) + " 筆")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(reject.item_count) + " 杯")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(reject.money) + " 元")])])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.rejectedOrderList) ? _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [(_vm.rejectedOrderList.length) ? _c('div', [_c('h6', [_vm._v("共損失 " + _vm._s(_vm.total.orderCount) + " 筆訂單")]), _vm._v(" "), _c('h6', [_vm._v(" " + _vm._s(_vm.total.itemCount) + " 杯飲料")]), _vm._v(" "), _c('h6', [_vm._v(" " + _vm._s(_vm.total.money) + " 元收入")])]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.roleType !== 10) ? _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 品牌 ==")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                    " + _vm._s(brand.label) + "\n                  ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 0 && _vm.brandSelect !== '0' && _vm.storeBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 門市 ==")]), _vm._v(" "), _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                    " + _vm._s(store.label) + "\n                  ")])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.week,
      "option": _vm.dateoption,
      "limit": _vm.weekLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "type": "button",
      "id": "search3"
    },
    on: {
      "click": function($event) {
        return _vm.setProductSale()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("銷售量統計(以週期計算)"), (_vm.brandSelect === 0 || _vm.brandSelect === '0') ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), (_vm.productSaleList.length) ? _c('div', {
    staticClass: "box-body p-0",
    staticStyle: {
      "min-height": "100px"
    }
  }, [(_vm.productSaleList.length) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.productSaleList[0]) ? _c('div', {
    staticClass: "col-xs-12 text-center col-md-4 col-lg-3"
  }, [_vm._m(8), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.productSaleList[0].name))])]) : _vm._e(), _vm._v(" "), (_vm.productSaleList[1]) ? _c('div', {
    staticClass: "col-xs-12 text-center col-md-4 col-lg-3 hidden-xs hidden-sm"
  }, [_vm._m(9), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.productSaleList[1].name))])]) : _vm._e(), _vm._v(" "), (_vm.productSaleList[2]) ? _c('div', {
    staticClass: "col-xs-12 text-center col-md-4 col-lg-3 hidden-xs hidden-sm"
  }, [_vm._m(10), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.productSaleList[2].name))])]) : _vm._e(), _vm._v(" "), (_vm.productSaleList[3]) ? _c('div', {
    staticClass: "col-xs-12 text-center col-md-4 col-lg-3 visible-lg-block"
  }, [_vm._m(11), _vm._v(" "), _c('h3', {
    staticClass: "text-yellow"
  }, [_vm._v(_vm._s(_vm.productSaleList[3].name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.productSaleList), function(product, index) {
    return (index + 1 <= 10) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      No." + _vm._s(index + 1) + "\n                    ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(product.name))])]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(product.amount) + " 杯\n                    ")])]) : _vm._e()
  }), 0)])])]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日使用者註冊狀態")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "today-shopper"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("累積使用者註冊狀態")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "total-shopper"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日不重複之使用者行為")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "shopper-active"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "order-transactions"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "money-transactions"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "amount-transactions"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    staticClass: "line-canvas",
    attrs: {
      "id": "rejected-orders"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "th-fit"
  }, [_vm._v("日期")]), _vm._v(" "), _c('th', [_vm._v("拒單原因 (狀態)")]), _vm._v(" "), _c('th', [_vm._v("筆數")]), _vm._v(" "), _c('th', [_vm._v("杯數")]), _vm._v(" "), _c('th', [_vm._v("金額")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/crown.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74e818b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Chart/Temp/SystemChart.vue
// module id = 2480
// module chunks = 1